import React from 'react';
export function Footer() {
  return <footer className="bg-background py-8 border-t border-border" data-id="element-80">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6 text-center md:text-left" data-id="element-81">
        <div className="flex flex-col gap-1" data-id="element-82">
          <div className="text-xl font-semibold tracking-tight text-primary" data-id="element-83">
            Марія Йосипівна
          </div>
          <div className="text-sm text-secondary" data-id="element-84">
            Бухгалтерські послуги · Досвід 20+ років
          </div>
        </div>

        <div className="flex flex-col items-center md:items-end gap-1" data-id="element-85">
          <a href="tel:+380000000000" className="text-primary font-medium hover:opacity-80 transition-opacity" data-id="element-86">
            +38 000 000 00 00
          </a>
          <div className="text-sm text-secondary" data-id="element-87">
            &copy; {new Date().getFullYear()} Всі права захищені.
          </div>
        </div>
      </div>
    </footer>;
}